// SETUP COUNTER BUTTON
function settingupCounterButtonLogic() {
  const productQuantityCounterInputSelector = '.product-counter input[type=text]';
  $('.product-counter .up').click(function () {
    const input = $(productQuantityCounterInputSelector);
    var value = parseInt(input.val(), 10);
    value = isNaN(value) ? 0 : value;
    value++;
    input.val(value);
  });
  $('.product-counter .down').click(function () {
    const input = $(productQuantityCounterInputSelector);
    var value = parseInt(input.val(), 10);
    if (value > 1) {
      value = isNaN(value) ? 0 : value;
      value--;
      input.val(value);
    }
  });
}

//SETUP ADD TO CART BUTTONS
function addToCartFromFloatingBtn() {
  $('.product_showcase_detailed_section_wrapper_content_buttons a').click(function () {
    const productId = $(this).attr('data-product-id');
    console.log(productId);
  });

  $('.mobile_floating_button .button_default_black').click(function () {
    console.log('works');
    $('.product_showcase_detailed_section_wrapper_content_buttons .button_default_yellow').trigger('click');
  });
}

//MOBILE NAVIGATION LOGIC
function burgerMenuSetup() {
  $('.header_main_wrapper_burger .header_main_wrapper_burger_link').click(function () {
    console.log('burger click');
    var x = document.querySelector('.header_main_burger_links');
    if (x.style.display === 'block') {
      x.style.display = 'none';
    } else {
      x.style.display = 'block';
    }
  });
}

//SETUP REVIEW AUTOMATIC LOADING

async function averageReviewForAllProducts() {
  const averageReviewCount = await fetch('https://qb54-api.wombatcloud.com/ugc/reviews/count_average')
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.error(err));
  console.log('Average review count');
  console.log(averageReviewCount);
  loadHeroReviews(averageReviewCount);
  return averageReviewCount;
}

function loadHeroReviews(averageObject) {
  const allPs = $('.home_hero_section_wrapper .home_hero_section_wrapper_content_reviews_estimation p');
  if (!allPs.length) {
    return;
  }

  console.log(averageObject);
  const averageScore = averageObject.average_score;
  const reviewsCount = averageObject.reviews_count;

  const reviewEstimation = allPs[0];
  const reviewCount = allPs[1];

  $('.home_hero_section_wrapper .home_hero_section_wrapper_content_reviews_estimation').replaceWith(`
    <div class="home_hero_section_wrapper_content_reviews_estimation">
      <p> 4.8/5 </p>
      <p> (${reviewsCount} Reviews)</p>
    </div>
    `);
}

function getHandleFromProductUrl(url) {
  const firstPart = 'products/';
  const lastPart = '?';

  const firstPartStartIndex = url.indexOf(firstPart);
  const lastPartIndex = url.indexOf(lastPart);

  const slicedStr = url.slice(firstPartStartIndex + firstPart.length, lastPartIndex === -1 ? url.length : lastPartIndex);

  return slicedStr;
}

async function getProductReviewsSummaryRequest(handle) {
  console.log('Requested URL');
  console.log('https://qb54-api.wombatcloud.com/core/products/get-product-reviews-summary/' + handle);
  console.log('https://qb54-api.wombatcloud.com/core/products/get-product-reviews-summary/' + handle);
  const productReviewsSummary = await fetch('https://qb54-api.wombatcloud.com/core/products/get-product-reviews-summary/' + handle)
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => {
      console.error(err);
      return {};
    });

  return productReviewsSummary;
}

function isContainsGameSet() {
  const titleH2 = $('.product_showcase_detailed_section_wrapper_content h1')[0];
  if (!titleH2) {
    console.warn('There is not element .product_showcase_detailed_section_wrapper_content h1');
    return;
  }
  const titleH2TitleLowerCased = titleH2.innerText ? titleH2.innerText.toLowerCase() : '';

  return (titleH2TitleLowerCased.includes('game') && titleH2TitleLowerCased.includes('set')) || (titleH2TitleLowerCased.includes('qb54') && titleH2TitleLowerCased.includes('set'));
}

async function loadProductReviewByHandleShowcase() {
  const productReviewsSummaryPs = $('.summary_reviews');
  if (!productReviewsSummaryPs.length) {
    return;
  }

  console.log('Passed');
  isContainsGameSet();

  const productReviewsSummaryP = $('.summary_reviews');
  const productHandle = isContainsGameSet() ? 'qb54-black-game-set' : getHandleFromProductUrl(window.location.href);

  // const productReviewsSummary = await getProductReviewsSummaryRequest(productHandle);
  const productReviewsSummary = await averageReviewForAllProducts();
  console.log('productReviewsSummary');
  console.log(productReviewsSummary);

  if (Object.keys(productReviewsSummary).length !== 0) {
    productReviewsSummaryP.text(`Based on ${productReviewsSummary.reviews_count} Customer Reviews`);
    console.log(productReviewsSummary);
  }
}

function setupCartSlider() {
  const moreSlider = document.querySelector('.js-moreslider');
  if (moreSlider) {
    let swiperMoreSlider = new Swiper('.js-moreslider', {
      spaceBetween: 100,
      slidesPerView: 3,
      speed: 800,
      loop: true,
      pagination: false,
      pagination: {
        el: '.p-cart-more-slider-pager',
        clickable: true,
      },
      autoplay: {
        delay: 4000,
      },
      navigation: {
        nextEl: '.js-next',
        prevEl: '.js-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        565: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
        1201: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
        1400: {
          slidesPerView: 3,
          spaceBetween: 100,
        },
      },
    });
  }
}
function faqSeo() {
  $('.faq_title').click(function (e) {
    let isActive = $(this).hasClass('is_selected');
    const accordionContent = $(this).next().find('.accordion_text');
    console.log(accordionContent);
    if (isActive) {
      $(this).removeClass('is_selected');
      // accordionContent.removeClass("is_selected");
      accordionContent.slideUp();
    } else {
      $(this).addClass('is_selected');
      accordionContent.removeClass('accordion_content');
      // accordionContent.parent().removeClass("hidden");
      accordionContent.slideDown();
    }
  });
}

$(document).ready(function () {
  // addToCartBtn();
  settingupCounterButtonLogic();
  addToCartFromFloatingBtn();
  burgerMenuSetup();
  averageReviewForAllProducts();
  loadProductReviewByHandleShowcase();
  setupCartSlider();
  // removeSepL();
  faqSeo();
  // setupCart();
  // reviewsPopupSetup();
});
